import { useMemo } from "react";
import { diffLines } from "@/lib/diff";
import { cn } from "@/lib/utils";

export function DiffView({ before, after, beforeLabel = "Before", afterLabel = "After" }: { before: string; after: string; beforeLabel?: string; afterLabel?: string }) {
  const lines = useMemo(() => diffLines(before, after), [before, after]);
  const changed = lines.some((l) => l.type !== "same");
  return (
    <div className="rounded-md border text-sm">
      <div className="flex gap-4 border-b bg-muted px-3 py-1 text-xs text-muted-foreground">
        <span>
          <span className="font-mono text-destructive">−</span> {beforeLabel}
        </span>
        <span>
          <span className="font-mono text-success">+</span> {afterLabel}
        </span>
        {!changed && <span>No differences</span>}
      </div>
      <pre className="max-h-80 overflow-auto p-2 font-mono text-xs leading-5 whitespace-pre-wrap">
        {lines.map((l, i) => (
          <div key={i} className={cn(l.type === "add" && "bg-success/15", l.type === "del" && "bg-destructive/15")}>
            <span aria-hidden className="mr-2 select-none text-muted-foreground">{l.type === "add" ? "+" : l.type === "del" ? "−" : " "}</span>
            <span className="sr-only">{l.type === "add" ? "added: " : l.type === "del" ? "removed: " : ""}</span>
            {l.text || " "}
          </div>
        ))}
      </pre>
    </div>
  );
}
